import { DebtLimitIncreaseStrategyType } from '@g2-shared/api-client/generated/risk-app';

export const DebtLimitIncreaseStrategyOptions: Record<DebtLimitIncreaseStrategyType, string> = {
  [DebtLimitIncreaseStrategyType.ABSOLUTE]: 'Absolute',
  [DebtLimitIncreaseStrategyType.PERCENTAGE]: 'Percentage',
};
